import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/** The healthcare line: the 8099 rule, none, or a specific approved code. */
export const hsaHealthLineChoice = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("default") }),
  z.object({ kind: z.literal("none") }),
  z.object({ kind: z.literal("mcc"), mcc: z.string() }),
]);

/**
 * Sets the business line and healthcare line, replacing the classifier's and
 * resolving a pending MCC review. Refused once the lines are at Adyen.
 */
export const setHsaMerchantLines = {
  name: "setHsaMerchantLines" as const,
  input: z.object({
    teamId: zExt.objectId(),
    primaryMcc: z.string(),
    health: hsaHealthLineChoice,
  }),
  output: z.object({ classification: hsaMerchantClassificationProjection }),
};
